import apiClient from '../client';
import type {
  CareTeamDto,
  CareTeamMemberDto,
  CreateCareTeamRequest,
  AddMemberRequest,
} from '@/types/careteam.types';

export const careTeamsApi = {
  // Care Teams
  getPatientCareTeams: async (patientId: string): Promise<CareTeamDto[]> => {
    const response = await apiClient.get<CareTeamDto[]>(
      `/v1/care-teams/patient/${patientId}`
    );
    return response.data;
  },

  getPatientActiveCareTeam: async (patientId: string): Promise<CareTeamDto | null> => {
    try {
      const response = await apiClient.get<CareTeamDto>(
        `/v1/care-teams/patient/${patientId}/active`
      );
      return response.data;
    } catch {
      return null;
    }
  },

  getById: async (id: string): Promise<CareTeamDto> => {
    const response = await apiClient.get<CareTeamDto>(`/v1/care-teams/${id}`);
    return response.data;
  },

  getUserCareTeams: async (userId: string): Promise<CareTeamDto[]> => {
    const response = await apiClient.get<CareTeamDto[]>(`/v1/care-teams/user/${userId}`);
    return response.data;
  },

  create: async (request: CreateCareTeamRequest): Promise<CareTeamDto> => {
    const response = await apiClient.post<CareTeamDto>('/v1/care-teams', request);
    return response.data;
  },

  dissolve: async (id: string): Promise<void> => {
    await apiClient.delete(`/v1/care-teams/${id}`);
  },

  // Care Team Members
  getMembers: async (careTeamId: string, activeOnly = false): Promise<CareTeamMemberDto[]> => {
    const response = await apiClient.get<CareTeamMemberDto[]>(
      `/v1/care-teams/${careTeamId}/members`,
      { params: { activeOnly } }
    );
    return response.data;
  },

  addMember: async (careTeamId: string, request: AddMemberRequest): Promise<CareTeamMemberDto> => {
    const response = await apiClient.post<CareTeamMemberDto>(
      `/v1/care-teams/${careTeamId}/members`,
      request
    );
    return response.data;
  },

  removeMember: async (memberId: string): Promise<void> => {
    await apiClient.delete(`/v1/care-teams/members/${memberId}`);
  },

  setCoordinator: async (memberId: string): Promise<CareTeamMemberDto> => {
    const response = await apiClient.patch<CareTeamMemberDto>(
      `/v1/care-teams/members/${memberId}/coordinator`
    );
    return response.data;
  },
};
